import React from 'react';
import FeatureReminderModal from './FeatureReminderModal';

type DiscountCodeReminderProps = {
  isVisible: boolean;
  onPressContinue: () => void;
};

const DiscountCodeReminder: React.FC<DiscountCodeReminderProps> = ({
  isVisible,
  onPressContinue
}) => (
  <FeatureReminderModal
    testId="discount-code-reminder"
    isVisible={isVisible}
    onPressContinue={onPressContinue}
    imageSrc="/img/feature-reminders/discount-code.gif"
    title="Discount Codes"
    description="Use Bounce's event discount codes to provide attendees special ticket prices! To get started, create your event and add the discount code details (ex. pricing, ticket limit, & more) on the event page."
  />
);

export default DiscountCodeReminder;
